import OrderInProgressBanner, { OrderInProgressBannerProps } from './OrderInProgressBanner';

export type { OrderInProgressBannerProps };
export default OrderInProgressBanner;
